export default __webpack_public_path__ + "fonts/new_tag.svg";